import { CheckoutDescription } from ".";
import { useLgScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { CheckoutForm } from "../CheckoutForm";
import { PricePreview } from "../CheckoutForm/PricePreview";
import { Column } from "../components/Column";
import { PaywallCustomization } from "./PaywallCustomization";

interface RootProps {
  className?: string;
  dataTestId?: string;
}

export const Root = ({
  className,
  dataTestId = "paywall-checkout-left-column",
}: RootProps) => {
  const { authProviderProperties } = usePaywallCheckoutContext();
  const isLgOrLargerScreen = useLgScreenMediaQuery();

  return (
    <Column
      className={classNames(
        "flex flex-row-reverse justify-center lg:justify-normal",
        className,
        {
          "pointer-events-none !hidden opacity-60 lg:!flex":
            authProviderProperties?.is_sso_authentication_required,
        },
      )}
      dataTestId={dataTestId}
    >
      <div className="flex flex-col gap-y-2">
        <CheckoutDescription.CommunityHeader />
        <PaywallCustomization.Countdown />
        <div
          className="bg-primary border-primary flex h-fit w-full flex-col rounded-xl border shadow-lg"
          data-testid="paywall-checkout-info"
        >
          <CheckoutDescription.Cover />
          <div className="flex flex-col gap-y-4 p-4 pb-5 md:p-7">
            <CheckoutDescription.PriceSelector />
            <CheckoutForm.CouponForm className="pb-4" />
            <PricePreview variant="with_modals" />
          </div>
        </div>
      </div>
      <PaywallCustomization shouldHide={!isLgOrLargerScreen} className="px-4" />
    </Column>
  );
};
